import Button from '@material-ui/core/Button';

import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';

// import ExtraReport from './ExtraReport'

import Grid from '@material-ui/core/Grid';

import React, {useEffect} from 'react';

import TextField from '@material-ui/core/TextField';

import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    width: '100%',
    backgroundColor: theme.palette.background.paper,
  },
  tableRightBorder : { borderWidth: 1, borderColor: 'black',borderStyle: 'solid'},
  tableRightBorderHeader : { borderWidth: 1, borderColor: 'white',borderStyle: 'solid'} 
}));

export default function Extra() {
    const classes = useStyles();
 
    const [noteInput, setNoteInput] = React.useState(()=> JSON.parse(window.localStorage.getItem('note')) || "");  

    useEffect(() => {
        window.localStorage.setItem("note", JSON.stringify(noteInput));
    }, [noteInput]);
    
    return (
    <div className={classes.root}>
      <Grid container spacing={24}>
        <Grid item xs={12} sm={12} container justify="flex-end">
            <Button variant="contained" color='secondary' startIcon={<DeleteOutlineIcon />} onClick={(event) => {
                var _noteInput = [...noteInput];
                _noteInput = '';
                setNoteInput(_noteInput);}} style={{backgroundColor:'#C71585', color:'white', marginBottom:'10px'}} >갑상선외 병변 초기화</Button>
        </Grid>
      </Grid>
        <TextField
          id="outlined-multiline-static"
          label="Extrathyroidal Lesion"
          multiline
          rows={4}
          defaultValue=""
          value = {noteInput}
          variant="outlined"
          style={{width:'100%'}}
          onChange={(event) => {
            var _noteInput = [...noteInput];
            _noteInput = event.target.value;
            setNoteInput(_noteInput);} }
        />
    </div>
    );
}